import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import FFormDrawerMDP, { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";
import FBtnMDP from "@/components/FBtnMDP";

export default class CFCancelPaymentFFormMDP extends FFormDrawerMDP {
    childMDP = new FFormChildMDP();
    parent: any;
    constructor(props: { parent: any }) {
        super({ myRefName: "CFCancelPaymentFFormRef", onClose: () => this.handleCloseClick(),isVisible: props.parent.showCancelForm, zIndex: "1000" });
        this.parent = props.parent;
        this.addField(new FTextareaMDP({
            dataSelectorKey: "reason",
            label: "Reason",
            parentMDP: this.childMDP,
            boundaryClass: "col-6"
        }))
            // .addAction(new FBtnMDP({
            //     label: "Close",
            //     onClick: this.handleCloseClick()
            // }))
            .addAction(new FBtnMDP({
                label: "Cancel Payment",
                onClick: () => this.handleCancelPayment()
            }))
    }

    handleCancelPayment() {
            const input: Data.ClientFile.CancelPaymentInput = Data.ClientFile.CancelPaymentInput.fromJson(this.parent.cancelInput);
            input.paymentId = this.parent.selectedPaymentToCancel.paymentId;
            Action.ClientFile.CancelPayment.execute(input, output => {
                this.parent.resetFormsTableAndData();
            });
    }
    handleCloseClick() {
        // return () => {
            this.parent.resetFormsTableAndData();
        // }
    }
}